/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { classNames } from '@ember-decorators/component';
import Editor from 'cio/components/action-composer/base/editor';
import afterRender from 'cio/utils/after-render';
import { getLiquidToInsert } from 'cio/utils/liquid';

@classNames('action-composer-panel', 'action-composer-panel--editor')
export default class UrbanAirshipEditor extends Editor {
  defaultRecipient = '{{customer.named_user}}';
  inputElement = null;

  @action
  insertLiquid([fieldName], liquid, fallback) {
    let fieldNameToSelector = {
      'template.to': '.js-editor-field-to input',
      'template.body': '.js-editor-textarea',
    };
    let selector = fieldNameToSelector[fieldName];

    if (!selector) {
      return;
    }

    let elem = this.element.querySelector(selector);
    let { selectionStart, selectionEnd, value } = elem;
    let beginStr = value.substr(0, selectionStart);
    let endStr = value.substr(selectionEnd, value.length);
    let liquidToInsert = getLiquidToInsert(liquid, fallback, this.args.editableEntity.template.templateEngine);

    elem.value = `${beginStr}${liquidToInsert}${endStr}`;
    elem.dispatchEvent(new Event('input', { bubbles: true }));
  }

  @action
  didInsertInput(inputElement) {
    this.inputElement = inputElement;
  }

  @action
  changeRecipient() {
    this.template.set('recipient', '');
    afterRender(() => {
      this.inputElement?.focus();
    });
  }

  @action
  useDefaultRecipient() {
    this.template.set('recipient', null);
  }
}
